import React, { Component, useState, useEffect } from "react";
import { Form, Dropdown, DropdownButton } from "react-bootstrap";
import classes from './style.module.css'
import { connect } from "react-redux"
import { SET_AVERAGE_SWITCH } from "../../../redux/actions"
import {AVEGAGE_SWITCH} from "../../../constants/Constants"


const AverageSwitch = props => {
    const selectAverageType = (event) => {
        console.log("..........." + event.currentTarget.value);
        props.setAverageSwitch(event.currentTarget.value);
    }

    return (
        <Form>
            <div key='radio' className={classes.AverageSwitch}>
                <Form.Check type='radio' id='check-api-radio'>
                    <div className={classes.radio}>
                        <Form.Check.Input type='radio' onClick={selectAverageType} name="a" value={AVEGAGE_SWITCH.LAST_3.id} 
                            checked={props.averageSwitch === AVEGAGE_SWITCH.LAST_3.id} />
                        <Form.Check.Label>Last 3 Average</Form.Check.Label>
                    </div>
                    <div className={classes.radio}>
                        <Form.Check.Input type='radio' name="a" onClick={selectAverageType} value={AVEGAGE_SWITCH.LAST_4.id} 
                         checked={props.averageSwitch === AVEGAGE_SWITCH.LAST_4.id} />
                        <Form.Check.Label>Last 4 Average</Form.Check.Label>
                    </div>
                    <div className={classes.radio}>
                        <Form.Check.Input type='radio' name="a" onClick={selectAverageType} value={AVEGAGE_SWITCH.LAST_5.id}  
                        checked={props.averageSwitch  === AVEGAGE_SWITCH.LAST_5.id} />
                        <Form.Check.Label>Last 5 Average</Form.Check.Label>
                    </div>
                </Form.Check>
            </div>

        </Form>
    );
}

const mapStateToProps = state => {
    return {
        averageSwitch: state.averageSwitch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setAverageSwitch: payload =>
            dispatch({ type: SET_AVERAGE_SWITCH, payload: payload })

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AverageSwitch);
